import './Gallery.css'
import React from 'react'
import { map, clone, isEmpty } from 'lodash'
import { Row, Col } from 'react-bootstrap'
import { keygen } from '../../services/firebase'
import Button from 'elements/CustomButton/CustomButton.jsx'
import { readImage } from '../../services/compressor'
import SweetAlert from 'react-bootstrap-sweetalert'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'

export default class Gallery extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            alert: null,
            selectedFromGallery: []
        }

        this.product = props.product
        this.notify = props.notify
        this.setCoverImage = props.setCoverImage
        this.addGalleryImage = props.addGalleryImage
        this.removeGalleryImage = props.removeGalleryImage
    }

    render() {
        const { product } = this.props
        const { alert, selectedFromGallery } = this.state
        return (
            <div className='gallery'>
                {alert}
                <Row>
                    <Col md={6} xs={12}>
                        <div className='gallery_block'>
                            <div className='gallery_header'>
                                <p className='header_title'>Imagem de capa</p>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='header_button'
                                    onClick={() => this.coverInput.click()}
                                >
                                    Selecionar
                                </Button>
                            </div>

                            <input
                                type='file'
                                ref={coverInput => this.coverInput = coverInput}
                                name='coverInput'
                                onChange={e => this._handleCoverImage(e.target.files[0])}
                                style={{ display: 'none' }}
                            />

                            <div className='cover_content'>
                                {this._handleCoverContent(product.coverImage)}
                            </div>
                        </div>
                    </Col>

                    <Col md={6} xs={12}>
                        <div className='gallery_block'>
                            <div className='gallery_header'>
                                <p className='header_title'>Imagens</p>
                                <Button
                                    bsStyle='default'
                                    wd
                                    className='header_button'
                                    onClick={() => this.galleryInput.click()}
                                >
                                    Adicionar
                                </Button>
                            </div>

                            <input
                                type='file'
                                ref={galleryInput => this.galleryInput = galleryInput}
                                name='galleryInput'
                                onChange={e => this._handleGalleryImage(e.target.files[0])}
                                style={{ display: 'none' }}
                            />

                            <div className='gallery_content'>
                                {this._handleGalleryContent(product.gallery)}
                                {this._handleRemoveImagesFromGalleryButton(selectedFromGallery)}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    async _readImage(image) {
        return await readImage(image)
    }

    async _handleCoverImage(image) {
        const coverImage = new Image()
        coverImage.src = await this._readImage(image)
        return image.type === 'image/png'
            || image.type === 'image/jpg'
            || image.type === 'image/jpeg'
            ? this.props.setCoverImage(coverImage)
            : this.props.notify('O arquivo selecionado não é uma imagem PNG ou JPG.', 'error')
    }

    async _handleGalleryImage(image) {
        const id = keygen()
        const galleryImage = new Image()
        galleryImage.src = await this._readImage(image)

        return image.type === 'image/png'
            || image.type === 'image/jpg'
            || image.type === 'image/jpeg'
            ? this.props.addGalleryImage({ image: galleryImage, id })
            : this.props.notify('O arquivo selecionado não é uma imagem PNG ou JPG.', 'error')
    }

    _handleCoverContent(image) {
        if (image) {
            const { src } = image
            return (
                <div>
                    <img
                        src={src}
                        alt='cover'
                        className={'cover_image'}
                    />
                    <div className='cover_controls' onClick={this.removeCoverAlert}>
                        <span className='cover_remove'>
                            Remover
                        </span>
                    </div>
                </div>
            )
        }

        if (!image) {
            return (
                <div className='gallery_placeholder'>
                    <span className='gallery_placeholder_title'>Nada aqui</span>
                    <span className='gallery_placeholder_info'>Selecione uma imagem de capa clicando no botão <b>Selecionar</b></span>
                </div>
            )
        }
    }

    _handleGalleryContent(images) {
        const { selectedFromGallery } = this.state
        if (!isEmpty(images)) {
            return map(images, item => {
                return (
                    <div
                        key={item.id}
                        className={`gallery_image_frame ${selectedFromGallery.indexOf(item.id) > -1 && 'gallery_selected'}`}
                        onClick={() => this._toggleGalleryImage(item.id)}
                    >
                        <img
                            src={item.image.src}
                            alt={`image_${item.id}`}
                            className='gallery_image'
                        />
                    </div>
                )
            })
        }

        if (!images.length) {
            return (
                <div className='gallery_placeholder'>
                    <span className='gallery_placeholder_title'>Nada aqui</span>
                    <span className='gallery_placeholder_info'>Adicione imagens ao produto clicando no botão <b>Adicionar</b></span>
                </div>
            )
        }
    }

    _handleRemoveImagesFromGalleryButton(selectedImages) {
        if (selectedImages.length) {
            return (
                <div className='gallery_controls' onClick={this.removeGalleryImagesAlert}>
                    <span className='gallery_remove'>
                        {`Remover ${selectedImages.length} ${selectedImages.length === 1 ? 'Imagem' : 'Imagens'}`}
                    </span>
                </div>
            )
        }
    }

    _toggleGalleryImage(id) {
        const selectedFromGallery = map(this.state.selectedFromGallery, clone())
        const imageIndex = selectedFromGallery.indexOf(id)
        imageIndex > -1
            ? selectedFromGallery.splice(imageIndex, 1) && this.setState({ selectedFromGallery })
            : selectedFromGallery.push(id) && this.setState({ selectedFromGallery })
    }

    _removeCoverImage() {
        this.hideAlert()
        return this.props.setCoverImage(null)
    }

    _removeImagesFromGallery() {
        this.hideAlert()
        map(this.state.selectedFromGallery, item => this.props.removeGalleryImage(item))
        return this.setState({ selectedFromGallery: [] })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeCoverAlert = () => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeCoverImage()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        });
    }

    removeGalleryImagesAlert = () => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeImagesFromGallery()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        })
    }

}


// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.jsx